/**
 * @fileoverview gRPC-Web generated client stub for external
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.external = require('./data_ingestion_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.external.DataIngestionServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.external.DataIngestionServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.external.IngestRentRollRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_DataIngestionService_IngestRentRoll = new grpc.web.MethodDescriptor(
  '/external.DataIngestionService/IngestRentRoll',
  grpc.web.MethodType.UNARY,
  proto.external.IngestRentRollRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.external.IngestRentRollRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.external.IngestRentRollRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_DataIngestionService_IngestRentRoll = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.external.IngestRentRollRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.external.IngestRentRollRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.external.DataIngestionServiceClient.prototype.ingestRentRoll =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/external.DataIngestionService/IngestRentRoll',
      request,
      metadata || {},
      methodDescriptor_DataIngestionService_IngestRentRoll,
      callback);
};


/**
 * @param {!proto.external.IngestRentRollRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.external.DataIngestionServicePromiseClient.prototype.ingestRentRoll =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/external.DataIngestionService/IngestRentRoll',
      request,
      metadata || {},
      methodDescriptor_DataIngestionService_IngestRentRoll);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.external.IngestActualsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_DataIngestionService_IngestActuals = new grpc.web.MethodDescriptor(
  '/external.DataIngestionService/IngestActuals',
  grpc.web.MethodType.UNARY,
  proto.external.IngestActualsRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.external.IngestActualsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.external.IngestActualsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_DataIngestionService_IngestActuals = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.external.IngestActualsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.external.IngestActualsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.external.DataIngestionServiceClient.prototype.ingestActuals =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/external.DataIngestionService/IngestActuals',
      request,
      metadata || {},
      methodDescriptor_DataIngestionService_IngestActuals,
      callback);
};


/**
 * @param {!proto.external.IngestActualsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.external.DataIngestionServicePromiseClient.prototype.ingestActuals =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/external.DataIngestionService/IngestActuals',
      request,
      metadata || {},
      methodDescriptor_DataIngestionService_IngestActuals);
};


module.exports = proto.external;

